// extracted by mini-css-extract-plugin
export default {"link":"BrowserCheck_link__1cN4q"};